import React from 'react'
import { CourseChip as CourseChipComponent, getImgProps } from '@superhi/design'

import { buildPath } from 'src/routing'
import { API } from 'src/api'

export const DURATION: Record<API.ProductCourseLength, string> = {
  EIGHT_WEEKS: 'Course',
  FOUR_SIX_WEEKS: 'Course',
  SHORT: 'Workshop',
}

type ComponentProps = Omit<
  React.ComponentProps<typeof CourseChipComponent>,
  'href' | 'duration' | 'difficultyLevel' | 'image'
>

type Props = ComponentProps & API.CourseChipComponent

const CourseChip: React.FC<React.PropsWithChildren<Props>> = ({
  slug,
  length,
  image,
  ...props
}) => {
  const imageProps = React.useMemo(
    () =>
      getImgProps(
        image.url,
        {
          small: 10,
          medium: 10,
          large: 5,
          xlarge: 5,
        },
        {
          fm: 'png8',
        },
      ),
    [image],
  )

  const href = React.useMemo(() => buildPath('courses-view', { params: { slug } }), [slug])

  return (
    <CourseChipComponent
      {...props}
      link={{ href }}
      duration={DURATION[length]}
      image={imageProps}
    />
  )
}

export { default as FRAGMENT } from './fragments'
export default CourseChip
